export enum UpdateSubscriptionTypesEnum{
    UPDATE_SHOP = 'UPDATE_SHOP',
    GET_SHOPS = 'GET_SHOPS',
    UPDATE_SHOP_IMAGE = 'UPDATE_SHOP_IMAGE',
    STORAGE_READY = 'STORAGE_READY'
}
